import { Router } from '@angular/router';
import { Component, EventEmitter, Input, Output, Renderer2, inject, } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators, } from '@angular/forms';
import { MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { CommonService } from '../../../services/common.service';
import { CommonModule } from '@angular/common';
import { MatStepperModule } from '@angular/material/stepper';
import { MatButtonModule } from '@angular/material/button';
import { HostConnectionService } from '../../../services/host-connection.service';
import { OriginService } from '../../../services/origin.service';
import { Origin, UnisourceRequestType, LogType, ProductType, } from '../../../models/loanData.model';
import { AuthService } from '../../../services/auth.service';

declare var $: any;
declare var bootstrap: any;

@Component({
  selector: 'app-admin-automated-options',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatButtonModule,
    MatStepperModule,
  ],
  templateUrl: './admin-automated-options.component.html',
  styleUrl: './admin-automated-options.component.css',
})
export class AdminAutomatedOptionsComponent {


  adminAutomatedOptionsForm!: FormGroup;

  templateTypeList: { id: number; name: string }[] = [
    { id: 1, name: 'Title Fees' },
    { id: 2, name: 'Title Order' },
  ];
  defaultTemplateType: any = this.templateTypeList[1]; //Order

  transactionTypeList: { id: number; name: string }[] = [
    { id: 0, name: 'Auto' },
    { id: 3, name: 'Purchase' },
    { id: 2, name: 'Refinance' },
    { id: 9, name: 'Assumptions' },
  ];
  defaultTransactionType: any = this.transactionTypeList[0]; //Auto


  private hostService = inject(HostConnectionService);
  private originService = inject(OriginService);
  private router = inject(Router);

  templateData!: any;
  productServiceAllList: ProductType[] = [];
  productServiceList: any[] = [];
  _originData!: Origin | null;
  transactionId: string = '57bc3e78-c608-4556-abe0-2e63496d31b2';

  compareIdNameObj = (obj1: any, obj2: any): boolean => {
    if (obj1 && obj2)
      return obj1.name === obj2.name;
    return obj1 === obj2;
  }

  feedbackMessage = 'Initializing...';
  loadingStatus: 'LOADING' | 'TIMEOUT' | 'ERROR' | 'LOGIN FAILED' | 'LOGIN' =
    'LOADING';

  constructor(
    public commonService: CommonService,
    private renderer: Renderer2,
    private authService: AuthService
  ) {
    this.loadAdminAutomatedOptionsFormControls();
  }



  async ngOnInit() {
    await this.hostService.initializeHostWithTransactionTemplate();
    this.getTransactionTemplateInformation();
  }

  ngAfterViewInit(): void {
    const transactionResponseAPIStatusModalElement = document.getElementById('transactionResponseAPIStatusModal');
    this.transactionResponseAPIStatusModalInstance = new bootstrap.Modal(transactionResponseAPIStatusModalElement, { backdrop: 'static', keyboard: false });
    
    this.descriptionPopover('transactionTypePopoverSelector', this.descriptionList);
  }

  ngOnDestroy() { }

  async getTransactionTemplateInformation() {
    try {
      console.log('Launch application: ', this.feedbackMessage);
      this.feedbackMessage = 'Connecting to Encompass Partner Connect...';
      setTimeout(() => { this.feedbackMessage = 'Authenticating...'; }, 1000);

      this.commonService.startSpinner();
      this.templateData = await this.hostService.getTransactionTemplate();
      console.log('gettransactionTemplate Response: ', this.templateData);
      this.productServiceAllList = await this.originService.getProductService();
      
      if (this.templateData) {
        this.adminAutomatedOptionsForm?.get('templateName')?.disable();
        this.rebindAdminAutomatedOptionsForm(this.templateData);
      }
      else {
        this.adminAutomatedOptionsForm?.get('templateName')?.enable();
        //this.commonService.openSnackBar('No data found', '', 'warning');
      }
    } catch (error: any) {
      this.commonService.stopSpinner();
      console.log('Error occurred while fetching transaction template: ', error.message);
      if (error.message === 'Requesting authentication token timed out.') {
      }
    }
    const transactionTypeObject = this.adminAutomatedOptionsForm.value?.transactionType || this.defaultTransactionType;
    this.onOrderTransactionTypeChange({
      value: transactionTypeObject,
      source: { triggerValue: transactionTypeObject.name },
    });
    this.commonService.stopSpinner();

  }


  loadAdminAutomatedOptionsFormControls() {
    this.adminAutomatedOptionsForm = new FormGroup({
      templateName: new FormControl('', [Validators.required]),
      templateType: new FormControl(this.defaultTemplateType, [Validators.required]),
      transactionType: new FormControl(this.defaultTransactionType, [Validators.required]),
      productServices: new FormControl('', [Validators.required]),
      //uninsured: new FormControl(false),
      //feeImport: new FormControl(false),
      //addFees: new FormControl(false),
    });
  }

  rebindAdminAutomatedOptionsForm(templateData: any) {
    const _data = templateData?.request?.options;
    if (_data)
      this.adminAutomatedOptionsForm.patchValue({
        templateName: _data?.templateName || '',
        templateType: _data?.templateType,
        transactionType: _data?.transactionType,
        productServices: _data?.productServices,
      });
      //this.onAutomatedTemplateTypeChange({value: _data?.templateType});
  }

  onAutomatedTemplateTypeChange(event: any): void {
    const selectedKey = event.value;
    //const selectedText = event.source.triggerValue;

  }

  onOrderTransactionTypeChange(event: any): void {
    const selectedKey = event.value;
    const selectedText = event.source.triggerValue;
    const isTransactionTypeAuto = selectedText === 'Auto';
    const emptyProduct = { id: 0, name: '' };
    this.productServiceList = this.productServiceAllList
      .filter((x) => x.transactionType === selectedText)
      .map((p) => ({
        id: p.productTypeID,
        name: p.productType,
      }));

    this.adminAutomatedOptionsForm.patchValue({
      transactionType: selectedKey,
      productServices: isTransactionTypeAuto ? emptyProduct : this.productServiceList[0]
    });
    if (isTransactionTypeAuto) {
      this.adminAutomatedOptionsForm.get('productServices')?.disable();
    } else {
      this.adminAutomatedOptionsForm.get('productServices')?.enable();
    }
  }
  onFeesTransactionTypeChange(event: any): void {
    const selectedKey = event.value;
    const selectedText = event.source.triggerValue;

  }

  confirmationOrder() {
    if (this.adminAutomatedOptionsForm.invalid) {
      this.adminAutomatedOptionsForm.markAllAsTouched();
      return;
    }
    this.onAdminAutomatedOptionsFormSubmit();
    //this.commonService.confirm('Confirmation', 'Create a new template anyway?').subscribe((confirmed: boolean) => {
    //  if (confirmed) {
    //    this.onAdminAutomatedOptionsFormSubmit();
    //  } else {
    //  }
    //});
  }
  async onAdminAutomatedOptionsFormSubmit() {
    // Destructure the properties you want to exclude and collect the rest
    //let { amount, policyDate, consideration, ...filteredOrderForm } = this.adminAutomatedOptionsForm.value;
    let automatedOptionsForm = this.adminAutomatedOptionsForm.getRawValue();
    const payload = {
      ...automatedOptionsForm,
      isAutomated: true,
      isNewOrder: true,
      //...(Object.keys(priorPolicy).length > 0 ? { priorPolicy } : {}),
    };
    const isFees = automatedOptionsForm?.templateType?.id === 1;
    const isHeloc = payload?.productServices?.id === 29;
    const requestType = isFees ? UnisourceRequestType.Fees : (isHeloc ? UnisourceRequestType.OrderUninsured : UnisourceRequestType.Order);

    // Build the transaction request
    const transactionRequest = {
      name: automatedOptionsForm?.templateName || '',
      request: {
        type: requestType,
        options: payload
      },
    };
    try {
      //this.disableCloseButton();
      //this.setTimeoutForEPCNotResponding();
      const result = await this.hostService.saveTemplate(transactionRequest);
      console.log('Transaction Template Save Response:', result);
      if (result) {
        this.closeInteraction();
        //this.commonService.openSnackBar('Transaction Template saved successfully', '', 'success');
        //this.transactionId = result?.id || '';
        //this.hostService.setTransactionId(this.transactionId);
        //this.clearEPCNotRespondingTimeout();
      }
    } catch (error: any) {
      //this.clearEPCNotRespondingTimeout();
      //this.enableCloseButton();
      console.log('Error occurred while creating Template transaction: ', { error });
      this.commonService.openSnackBar('Error occurred while transaction save', '', 'error');
    }
  }

  getErrorMessage(dataObject: any): string {
    return this.commonService.getErrorMessage(dataObject);
  }

  onReset(): void {
    this.commonService.onReset(this.adminAutomatedOptionsForm);
  }


  closeInteraction() {
    this.commonService.destroyPopoverEvents();
    this.hostService.closeTemplate();
  }

  orderProcessingMessage: string = 'Loading...';
  isProcessDoneLoading: boolean = false;
  reInitializeTransactionProcess() {
    this.orderProcessingMessage = 'Initiating...';
  }
  onProcessDoneButtonClick() {
    this.isProcessDoneLoading = true;
    this.isEPCNotRespondingLoading = true;
    setTimeout(() => {
      this.isProcessDoneLoading = false;
      this.isEPCNotRespondingLoading = false;
      this.reInitializeTransactionProcess();
      this.hostService.closeTemplate();
    }, 1000);
  }


  isEPCNotRespondingLoading: boolean = false;
  epcNotRespondingIntervalTimeoutId: any;
  setTimeoutForEPCNotResponding() {
    if (this.epcNotRespondingIntervalTimeoutId) clearTimeout(this.epcNotRespondingIntervalTimeoutId);
    this.epcNotRespondingIntervalTimeoutId = setTimeout(() => {
      this.transactionNotRespondingLog();
    }, 15 * 1000); // 15 seconds in milliseconds
  }
  clearEPCNotRespondingTimeout() {
    clearTimeout(this.epcNotRespondingIntervalTimeoutId);
    this.epcNotRespondingIntervalTimeoutId = null;
    this.hideTransactionResponseAPIStatusDetailModal();
  }
  async transactionNotRespondingLog() {
    const logData = {
      message: "The EPC system is taking longer than expected to respond.",
      level: LogType.Error,
      //loanNumber: this.loanNumber,
      //instanceId: this.instanceId,
      source: "Transaction"//"Title Fee (Update Transaction)"
    }
    this.showTransactionResponseAPIStatusDetailModal();
    const response = await this.originService.integrationsLog(logData);
  }
  transactionNotRespondingWaitBtn() {
    this.clearEPCNotRespondingTimeout();
    this.setTimeoutForEPCNotResponding();
  }

  transactionResponseAPIStatusModalInstance: any;
  showTransactionResponseAPIStatusDetailModal() {
    this.transactionResponseAPIStatusModalInstance.show();
  }
  hideTransactionResponseAPIStatusDetailModal() {
    this.transactionResponseAPIStatusModalInstance.hide();
  }


  disableCloseButton() {
    const closeBtn = document.getElementById('closeAppBtn');
    if (closeBtn) {
      this.renderer.setAttribute(closeBtn, 'disabled', 'true');
    }
  }

  enableCloseButton() {
    const closeBtn = document.getElementById('closeAppBtn');
    if (closeBtn) {
      this.renderer.removeAttribute(closeBtn, 'disabled');
    }
  }

  opensessionDialog() {
    this.commonService.openSessionExpiredModal();
  }

  isSessionResetLoading: boolean = false;
  async resetApp() {
    //location.reload(); // or use router.navigate(['/login']) 
    this.isSessionResetLoading = true;

    var transactionTemplate = await this.hostService.getTransactionTemplate();
    console.log(transactionTemplate);
    this.transactionId = transactionTemplate.transactionId || '';
    //this._originData = await this.originService.getLoanData(transactionTemplate.id, transactionTemplate.partnerAccessToken);
    //this.authService.setJWTToken(this._originData?.jwtToken || '');

    this.isSessionResetLoading = false;
    this.commonService.closeSessionExpiredModal();
  }


 descriptionList = [
   {title: '"Auto"', description: 'Automatically detects the transaction type based on the loan purpose (e.g., Purchase or Refinance).'},
   {title: '"Purchase"', description: 'Submits an order as a standard Purchase transaction.'},
   {title: '"Refinance"', description: 'Submits an order as a Refinance (Cash-Out or No Cash-Out) transaction.'},
   {title: '"Assumptions"', description: 'Submits the order as an Assumption transaction.'}
  ];

  descriptionPopover(popoverSelector: string, descriptions: any) {
    setTimeout(() => {
      this.commonService.descriptionPopoverContent(`.${popoverSelector}`, descriptions);
      $('[data-toggle="popover"]').popover();
    }, 100);
  }

}
